import React from 'react';

import { StyledEngineProvider } from '@mui/material';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import '@fontsource-variable/inter';
import '@fontsource-variable/manrope';
import '@fontsource-variable/jetbrains-mono';
// Only downloaded when a visitor turns on "Readable font".
import '@fontsource/atkinson-hyperlegible/latin-400.css';
import '@fontsource/atkinson-hyperlegible/latin-700.css';
import './index.css';
import './font.css';
import { loadSavedPreferences } from './accessibility/preferences';
import { startCtaCounting } from './analytics/ctaCounts';
import Demo from './Demo';
import { startBrowserErrorMonitoring } from './monitoring/bootstrap';
import { claimPrerenderedRoot } from './prerender/hydration';

loadSavedPreferences();
startBrowserErrorMonitoring();
startCtaCounting();

const container = document.getElementById('root')!;
const app = (
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <BrowserRouter>
        <Demo />
      </BrowserRouter>
    </StyledEngineProvider>
  </React.StrictMode>
);

// Prerendered pages already contain the page body, so attach to it instead of replacing it.
// Anything else, such as a fallback to another page's HTML, is rendered from scratch.
if (claimPrerenderedRoot(container, window.location.pathname)) {
  ReactDOM.hydrateRoot(container, app);
} else {
  container.replaceChildren();
  ReactDOM.createRoot(container).render(app);
}
